// extracted by mini-css-extract-plugin
export default {"main_div":"Searchbar_main_div__+s7zu","input_box":"Searchbar_input_box__j8WVe"};